import RightArrowIcon from './component.jsx'

export default RightArrowIcon
